// extracted by mini-css-extract-plugin
export default {"cls1":"Ces8VWdjgX3L4LsFs9XX","cls2":"JRoR0pTPbP5OZsNmqztw Ces8VWdjgX3L4LsFs9XX"};